import { useState } from 'react';
import { SquareX, SquareCheck, ChevronRight, ChevronDown, ChevronUp } from "lucide-react";
import ReactMarkdown from 'react-markdown';

const ToggleBlock = ({ header, text, defaultOpen=false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="w-full border rounded-md shadow-sm">
      {/* Заголовок */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full text-left px-4 py-3 bg-gray-100 hover:bg-gray-200 transition rounded-t-md flex justify-left items-center"
      >
        {isOpen === false &&(
          <ChevronRight className="h-6 w-6 text-gray-500 mr-2" />
        )}
        {isOpen === true &&(
          <ChevronDown className="h-6 w-6 text-gray-500 mr-2" />
        )}
        <h2 className="text-sm font-semibold">{header}</h2>
      </button>

      {/* Содержимое (условный рендеринг) */}
      {isOpen && (
        <div className="px-4 py-3 bg-white border-t">
          <p className="text-sm text-gray-700" style={{ lineHeight: '1.8' }}>
            <ReactMarkdown>{text}</ReactMarkdown>
          </p>
        </div>
      )}
    </div>
  );
};

export default ToggleBlock;